/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../controllers/screencontrollerbase.ts" />

module App.Common.Controllers {
	'use strict';

	class PasswordResetRequestedController extends Controllers.ScreenControllerBase {

		public static $inject = ['$injector'];

		private titleRequestPassword = 'Request a password reset';
		private titleThankYou = 'Thank you, now check your email';

		public hasRequestedPassword = false;
		public username : string;

		constructor($injector: angular.auto.IInjectorService) {
			super($injector);
			this.fullWidth = true;
			this.warnOnUnsavedChanges = false;
		}

		public beforeInitialize(): angular.IPromise<any> {
			return this.setAuthenticationRequired(false);
		}

		public initialize(): angular.IPromise<any> {
			this.setTitle();
			return this.$q.resolve();
		}

		/**
		 * Request a password reset.
		 * This results in an email being sent to the user which
		 * prompts the user to follow a link to resaet their password.
		 */
		public requestPasswordReset(): void {
			//built the request
			let request = {
				url: this.globalSettings.authenticationEndpoints.requestPasswordReset,
				deferUserMessageDisplay: true,
				suppressSuccessMessage: true,
				authenticated: false,
				data: {
					emailAddress: this.username,
					useWindowsAuthentication: false,
					resetUrl: this.globalSettings.baseUrl
					+ this.$state.get('ResetPassword').url.toString()
						.replace(':id', '{token}')
						.replace(':source', '{source}')
				}
			};
			//perform the request
			this.busyPromise = this.api.post(request).then(() => {
				this.hasRequestedPassword = true;
			}).catch(() => {
				this.userMessages.clear();
				this.hasRequestedPassword = false;
			});
		}

		private setTitle(): void {
			this.title = this.hasRequestedPassword ? this.titleThankYou : this.titleRequestPassword;
		}

	}

	angular
		.module('app.common.controllers')
		.controller('app.common.controllers.passwordResetRequestedController', PasswordResetRequestedController);

}